import React, { useState } from "react";
import styles from "./learningZoneBtns.module.css";
import { IoMdPersonAdd } from "react-icons/io";
import { HiUserGroup } from "react-icons/hi";
import LearningZoneInviteModal from "../learningZoneModals/learningZoneInviteModal/LearningZoneInviteModal";
import LearningZoneUsersModal from "../learningZoneModals/learningZoneUsersModal/LearningZoneUsersModal";

const LearningZoneBtnsComp = ({
  username,
  isCreatorOrAdmin,
  lzCreatorUsername,
  learningZoneData,
}) => {
  /* This component is responsible for the learning zone buttons: invite users, and show users. Both buttons open modals with additional functionality. */

  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isUsersModalOpen, setIsUsersModalOpen] = useState(false);

  const learningZoneId =
    learningZoneData.learningZone.basicLZInfo[0].learning_zone_id;

  const learningZoneName =
    learningZoneData.learningZone.basicLZInfo[0].learning_zone_name;

  /* Show the invite users modal */
  const openInviteModal = () => {
    setIsInviteModalOpen(true);
  };

  /* Close the invite users modal */
  const closeInviteModal = () => {
    setIsInviteModalOpen(false);
  };

  /* Show the show users modal */
  const openUsersModal = () => {
    setIsUsersModalOpen(true);
  };

  /* Close the show users modal */
  const closeUsersModal = () => {
    setIsUsersModalOpen(false);
  };

  return (
    <div className={styles.btnsComp}>
      <div className={styles.btnContainer}>
        {isCreatorOrAdmin && (
          <button onClick={openInviteModal}>
            <span className={styles.btnIcon}>
              <IoMdPersonAdd />
            </span>
            Invite a User
          </button>
        )}
      </div>
      <div className={styles.btnContainer}>
        <button onClick={openUsersModal}>
          <span className={styles.btnIcon}>
            <HiUserGroup />
          </span>
          Show Users
        </button>
      </div>
      <LearningZoneInviteModal
        isOpen={isInviteModalOpen}
        onClose={closeInviteModal}
        activeUsername={username}
        learningZoneId={learningZoneId}
        learningZoneName={learningZoneName}
      />
      <LearningZoneUsersModal
        isOpen={isUsersModalOpen}
        onClose={closeUsersModal}
        learningZoneId={learningZoneId}
        learningZoneName={learningZoneName}
        lzCreatorUsername={lzCreatorUsername}
        isCreatorOrAdmin={isCreatorOrAdmin}
      />
    </div>
  );
};

export default LearningZoneBtnsComp;
